/* eslint-disable */
/* tslint:disable */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  NgZone,
  TemplateRef,
} from '@angular/core';
import { ProxyCmp, proxyOutputs } from '../angular-component-lib/utils';
import { Components } from '@bkkr/core';
export declare interface BkkrModal extends Components.BkkrModal {
  /**
   * Emitted after the modal has presented.
   **/
  bkkrModalDidPresent: EventEmitter<CustomEvent>;
  /**
   * Emitted before the modal has presented.
   */
  bkkrModalWillPresent: EventEmitter<CustomEvent>;
  /**
   * Emitted before the modal has dismissed.
   */
  bkkrModalWillDismiss: EventEmitter<CustomEvent>;
  /**
   * Emitted after the modal has dismissed.
   */
  bkkrModalDidDismiss: EventEmitter<CustomEvent>;
  /**
   * Emitted after the modal has presented. Shorthand for bkkrModalWillDismiss.
   */
  didPresent: EventEmitter<CustomEvent>;
  /**
   * Emitted before the modal has presented. Shorthand for bkkrModalWillPresent.
   */
  willPresent: EventEmitter<CustomEvent>;
  /**
   * Emitted before the modal has dismissed. Shorthand for bkkrModalWillDismiss.
   */
  willDismiss: EventEmitter<CustomEvent>;
  /**
   * Emitted after the modal has dismissed. Shorthand for bkkrModalDidDismiss.
   */
  didDismiss: EventEmitter<CustomEvent>;
}

@ProxyCmp({
  inputs: [
    'animated',
    'backdropDismiss',
    'canDismiss',
    'closeButton',
    'closeIcon',
    'cssClass',
    'enterAnimation',
    'event',
    'handle',
    'isOpen',
    'keepContentsMounted',
    'keyboardClose',
    'leaveAnimation',
    'presentingElement',
    'showBackdrop',
    'swipeToClose',
    'trigger',
  ],
  methods: ['present', 'dismiss', 'onDidDismiss', 'onWillDismiss'],
})
@Component({
  selector: 'bkkr-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div class="bkkr-page" *ngIf="isCmpOpen || keepContentsMounted">
    <ng-container [ngTemplateOutlet]="template"></ng-container>
  </div>`,
  inputs: [
    'animated',
    'backdropDismiss',
    'canDismiss',
    'closeButton',
    'closeIcon',
    'cssClass',
    'enterAnimation',
    'event',
    'handle',
    'isOpen',
    'keepContentsMounted',
    'keyboardClose',
    'leaveAnimation',
    'presentingElement',
    'showBackdrop',
    'swipeToClose',
    'trigger',
  ],
})
export class BkkrModal {
  @ContentChild(TemplateRef, { static: false }) template: TemplateRef<any>;

  isCmpOpen: boolean = false;

  protected el: HTMLElement;

  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    this.el = r.nativeElement;

    this.el.addEventListener('willPresent', () => {
      this.isCmpOpen = true;
      c.detectChanges();
    });
    this.el.addEventListener('didDismiss', () => {
      this.isCmpOpen = false;
      c.detectChanges();
    });

    proxyOutputs(this, this.el, [
      'bkkrModalDidPresent',
      'bkkrModalWillPresent',
      'bkkrModalWillDismiss',
      'bkkrModalDidDismiss',
      'didPresent',
      'willPresent',
      'willDismiss',
      'didDismiss',
    ]);
  }
}
